import { type FilterOptionsState, createFilterOptions } from "@mui/material";

export const autocompleteSourcesFilterOptions = <T extends { label: string }>(
  options: T[],
  params: FilterOptionsState<T>
) => createFilterOptions<T>({ ignoreAccents: true, ignoreCase: true })(options, params);
